// libraries.
import { Spinner } from 'react-bootstrap';
import { monserratSemiBold } from '@habitech/shared';

interface LoadingOverlayProps {
  isLoading: boolean;
  loadingText?: string;
}

export const LoadingOverlay = ({
  isLoading,
  loadingText = 'Buscando coordenadas...',
}: LoadingOverlayProps) => {
  if (!isLoading) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1rem',
        zIndex: 9999,
      }}
    >
      <Spinner animation="border" variant="light" />
      <span
        style={{
          fontFamily: monserratSemiBold,
          fontSize: '14px',
          color: 'white',
        }}
      >
        {loadingText}
      </span>
    </div>
  );
};
